<template>
  <div class="plan">
    <div
      v-if="showTitle || showSettings"
      :class="[
        showTitle
          ? 'titolo navy--text text--lighten-2 pb-1 font-hemi-head d-flex align-center'
          : 'plan-settings-toolbar',
      ]"
    >
      <div v-if="showTitle">Pianificazione Rosa</div>
      <v-btn
        x-small
        rounded
        depressed
        class="section-title-action-btn navy darken-3 navy--text text--lighten-3 px-2 ml-1"
        title="Impostazioni pianificazione"
        @click="promptDialogPlanSettings"
      >
        <v-icon x-small>tune</v-icon>
      </v-btn>
    </div>

    <div v-if="showTitle && showButtonRose" class="d-flex justify-center">
      <v-btn
        small
        color="primary"
        class="px-4 font-weight-bold white--text"
        @click="showDialogRoseLega"
      >
        <v-icon small left color="white">groups</v-icon>
        Rose
        <v-icon small right color="white">chevron_right</v-icon>
      </v-btn>
    </div>

      <div v-if="!my_squadra" class="pa-10">
        Attenzione. Solo i partecipanti all'asta possono pianificare le
        strategia di acquisto
      </div>

      <div v-else class="plan-content">
        <asta-consiglio></asta-consiglio>
        <v-list :class="{ 'nice-scroll': !is_mobile }" class="recycle-scroller">
          <div v-for="(slots, ruolo_abc) in myPlan" :key="ruolo_abc">
            <asta-slot
              v-for="(slotData, slot, i) in slots"
              :key="ruolo_abc + '_' + slot"
              :ruolo_abc="ruolo_abc"
              :iSlot="slot"
              :i="i"
            ></asta-slot>
            <div
              v-if="(acquistiSenzaSlotPerRuolo[ruolo_abc] || []).length > slotLiberi(ruolo_abc).length"
              class="plan-fuori-limite"
              :style="{ '--plan-role-color': 'var(--ruolo-' + Constants.RUOLO[ruolo_abc] + ')' }"
            >
              <div class="plan-fuori-limite-title font-weight-bold px-2">
                {{ ruolo_abc }} — Acquistati senza slot
              </div>
              <!-- <div class="px-2 pb-2 text-caption">
                Sono già nella tua rosa quindi il loro costo é considerato dalla pianificazione.
                <span v-if="!slotLiberi(ruolo_abc).length">Nessuno slot libero per questo ruolo.</span>
              </div> -->
              <div
                v-if="['=', '<='].includes(asta_info.lega.nRuoli.op)"
                class="px-2 pb-2 text-caption"
                role="alert"
              >
                <v-icon x-small class="plan-fuori-limite-title">warning</v-icon>
                Gli slot disponibili non bastano per tutti gli acquistati.
                Può succedere se l’amministratore riduce troppo il numero di calciatori
                acquistabili per questo ruolo dopo che le assegnazioni erano giá avvenute in Asta Live.
                Chiedi all’amministratore di verificare il limite impostato e di aumentarlo (oppure eliminare le assegnazioni in eccesso)
              </div>
              <div
                v-for="id in acquistiSenzaSlotPerRuolo[ruolo_abc]"
                :key="'senza-slot-' + id"
                class="plan-acquistato-senza-slot"
              >
                <maglia-or-flag-plus-nome :calciatore="calciatori[id]" />
                <span class="plan-acquistato-nome">{{ calciatori[id].calciatore }}</span>
                <crediti :crediti="my_squadra.calciatori[id].p || 0" />
                <v-btn
                  v-if="slotLiberi(ruolo_abc).length"
                  x-small outlined rounded
                  @click="associaAcquistato(id)"
                >Associa</v-btn>
              </div>
            </div>
            <!-- Sezione nascosta: i crediti fuori limite restano esclusi dai conteggi.
            <div
              v-if="Object.keys(myPlanFuoriLimite[ruolo_abc] || {}).length"
              class="plan-fuori-limite"
              :style="{ '--plan-role-color': 'var(--ruolo-' + Constants.RUOLO[ruolo_abc] + ')' }"
            >
              <div class="plan-fuori-limite-title font-weight-bold px-2">
                {{ ruolo_abc }} — Slot oltre il limite
              </div>
              <div class="px-2 pb-2 text-caption">
                I crediti pianificati qui verranno ignorati.
              </div>
              <div
                v-for="(slotData, slot) in myPlanFuoriLimite[ruolo_abc]"
                :key="ruolo_abc + '_conservato_' + slot"
              >
                <div class="px-2 text-caption">Slot {{ slot.slice(1) }}</div>
                <asta-slot
                  :ruolo_abc="ruolo_abc"
                  :iSlot="slot"
                  :i="Number(slot.slice(1)) - 1"
                ></asta-slot>
              </div>
            </div>
            -->
          </div>
        </v-list>
        <asta-plan-numpad></asta-plan-numpad>
        <dialog-associa-calciatore></dialog-associa-calciatore>
        <dialog-associa-slot></dialog-associa-slot>
        <dialog-plan-settings></dialog-plan-settings>
        <dialog-plan-strategia></dialog-plan-strategia>
        <dialog-plan-obiettivo></dialog-plan-obiettivo>
      </div>
    </div>
</template>

<script>
import db from "../js/db";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import AstaSlot from "./AstaSlot";
import AstaConsiglio from "./AstaConsiglio";
import MagliaOrFlagPlusNome from "./common/MagliaOrFlagPlusNome";
import Crediti from "./common/Crediti";
import AstaPlanNumpad from "./dialogs/AstaPlanNumpad";
import DialogAssociaCalciatore from "./dialogs/DialogAssociaCalciatore";
import DialogAssociaSlot from "./dialogs/DialogAssociaSlot";
import DialogPlanSettings from "./dialogs/DialogPlanSettings";
import DialogPlanStrategia from "./dialogs/DialogPlanStrategia";
import DialogPlanObiettivo from "./dialogs/DialogPlanObiettivo";
import Vuex from "vuex";

export default {
  name: "asta-plan",
  components: {
    AstaSlot,
    AstaPlanNumpad,
    DialogAssociaCalciatore,
    DialogAssociaSlot,
    DialogPlanSettings,
    DialogPlanStrategia,
    DialogPlanObiettivo,
    AstaConsiglio,
    MagliaOrFlagPlusNome,
    Crediti,
  },
  mixins: [mixins, toast],
  data() {
    return {
      // tipoConsiglio: "neutro",
      // effectConsiglio: "",
      // actionConsiglio: null,
      // actionConsiglioText: "",
      // numNoCrediti: 0,
      calciatoreDaAssociare: null,
    };
  },
  props: {
    showButtonRose: {
      type: Boolean,
      default: true,
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
    showSettings: {
      type: Boolean,
      default: false,
    },
  },
  created() {},
  mounted() {
    console.log("--> AstaPlan mounted.");
    db.on("calciatoreAssegnato", this.handleAssegnazione);
  },
  destroyed() {
    console.log("<-- AstaPlan destroyed.");
    db.off("calciatoreAssegnato", this.handleAssegnazione);
  },
  methods: {
    promptDialogPlanSettings() {
      db.emit("DialogPlanSettings");
    },
    associaAcquistato(id) {
      db.emit("DialogAssociaSlot", id);
    },
    slotLiberi(ruolo) {
      return Object.keys(this.myPlan[ruolo] || {}).filter(
        slot => !this.myPlan[ruolo][slot].associato
      );
    },
    showDialogRoseLega() {
      db.emit("showDialogRoseLega");
    },
    promptDialogAssociaSlot() {
      if (this.calciatoreDaAssociare) {
        db.emit("DialogAssociaSlot", this.calciatoreDaAssociare);
      }
    },
    isPianificato(calciatore_id, ruolo_abc) {
      let output = null;
      for (const slot in this.myPlan[ruolo_abc]) {
        // solo se non è già uno slot associato
        if (this.myPlan[ruolo_abc][slot]["associato"] == "") {
          // sennò controlla se era pianificato in questo slot
          const calciatori = Object.values(this.myPlan[ruolo_abc][slot]["calciatori"] || []);
          if (calciatori.includes(calciatore_id)) {
            output = slot;
            return output;
          }
        }
      }
      return output;
    },
    getFreeSlot(ruolo_abc) {
      for (const slot in this.myPlan[ruolo_abc]) {
        // se non è già uno slot associato
        if (this.myPlan[ruolo_abc][slot]["associato"] == "") {
          return slot;
        }
      }
      return null;
    },
    getBestFreeSlotByCrediti(ruolo_abc, prezzo) {
      const firstFreeSlot = this.getFreeSlot(ruolo_abc);
      if (!firstFreeSlot) {
        return null;
      }

      const prezzoPagato = parseInt(prezzo) || 0;
      let bestSlot = null;
      let bestDelta = null;

      for (const slot in this.myPlan[ruolo_abc]) {
        const slotData = this.myPlan[ruolo_abc][slot];
        if (slotData["associato"] != "") {
          continue;
        }

        const creditiPianificati = parseInt(slotData["crediti"]) || 0;
        if (creditiPianificati <= 0) {
          continue;
        }

        const delta = Math.abs(creditiPianificati - prezzoPagato);
        if (bestDelta === null || delta < bestDelta) {
          bestDelta = delta;
          bestSlot = slot;
        }
      }

      return bestSlot || firstFreeSlot;
    },
    handleAssegnazione(assegnazione) {
      // Unlimited purchases are handled by Asta even when this panel is closed.
      if (this.asta_info.lega.nRuoli.op === "illimitati") return;
      const calciatore_id = assegnazione.calciatore_id;
      const squadra_id = assegnazione.squadra_id;
      const prezzo = assegnazione.prezzo;
      if (this.my_squadra && squadra_id == this.my_squadra.id) {
        // se è già stato associato nella pianificazione, nn fare nulla
        // (potrebbe capitare quando aggiorno la pagina e l'ultimo log è un'assegnazione)
        if (!this.associati.includes(calciatore_id)) {
          const ruolo_id = this.calciatori[calciatore_id].ID_Ruolo;
          const ruolo_abc = _.invert(Constants.RUOLO)[ruolo_id];
          const slot = this.isPianificato(calciatore_id, ruolo_abc);
          if (slot) {
            // è tra i pianificati in uno slot non ancora associato
            db.setPlanAssociato(ruolo_abc, slot, calciatore_id);
          } else {
            // non è tra i pianificati
            const freeSlot = this.getBestFreeSlotByCrediti(ruolo_abc, prezzo);
            if (freeSlot) {
              db.setPlanAssociato(ruolo_abc, freeSlot, calciatore_id);
            }
          }
        }
      }
    },
  },

  computed: {
    ...Vuex.mapGetters(["myPlan", "myPlanFuoriLimite", "associati", "acquistiSenzaSlotPerRuolo"]),
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.plan {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.plan-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.plan-settings-toolbar {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  padding: 8px 10px 4px;
}

.plan-fuori-limite {
  margin: 12px 4px;
  padding: 8px 0;
  border: 1px dashed var(--plan-role-color);
  border-radius: 4px;
}

.plan-fuori-limite-title {
  color: var(--plan-role-color);
}

.plan-acquistato-senza-slot {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
}

.plan-acquistato-nome {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
